import React from 'react';
import PropTypes from 'prop-types';

import 'commons-vehicle/Vehicle/components/VehicleBannerWithCarrousel/Photos/Photos.scss';

class ExpandPhoto extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        event.preventDefault();
        this.props.togglePhotoLightBox(0);
    }

    render() {
        return (
            <div className="vehicleBanner-photos-expand clearfix">
                <button type="button" className="photo-expand" onClick={this.handleClick}>
                    <icon className="icon-expand" />
                </button>
            </div>
        );
    }
}

ExpandPhoto.propTypes = {
    togglePhotoLightBox: PropTypes.func.isRequired,
};

ExpandPhoto.displayName = 'ExpandPhoto';

export default ExpandPhoto;
